import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

/** Resolves /:collectionSlug/:styleSlug → upload page.
 *  - Minimalist: /minimalist/<anything> → /upload?category=minimalist
 *  - Renaissance: /renaissance/<anything> → /upload?category=renaissance
 *    (Renaissance no longer has per-style subcategories — gender is picked on
 *    the upload page itself.)
 *  Unknown collection → fall back to homepage. */
const StyleRouter = () => {
  const { collectionSlug } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    const cs = (collectionSlug || "").toLowerCase();
    if (cs === "minimalist") {
      navigate(`/upload?category=minimalist`, { replace: true });
      return;
    }
    if (cs === "renaissance") {
      navigate(`/upload?category=renaissance`, { replace: true });
      return;
    }
    navigate(`/`, { replace: true });
  }, [collectionSlug, navigate]);
  return null;
};

export default StyleRouter;
